<button
  type="button"
  appButton
  variant="neutral"
  iconOnly
  class="mobile-secondary-menu__toggle"
  (click)="toggle()"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-label]="'header.secondaryMenu' | translate"
  >
  <fa-icon [icon]="faBars"></fa-icon>
</button>

<div
  class="mobile-slide-menu"
  [class.mobile-slide-menu--open]="isOpen()"
  [attr.aria-hidden]="!isOpen()"
  >
  <button
    type="button"
    class="mobile-slide-menu__backdrop"
    appInteractive
    motion="none"
    tabindex="-1"
    [attr.aria-label]="'header.closeSecondaryMenu' | translate"
    (click)="close()"
  ></button>

  <aside
    class="mobile-slide-menu__panel"
    role="dialog"
    [attr.aria-modal]="isOpen()"
    [attr.aria-label]="'header.secondaryMenu' | translate"
    >
    <header class="mobile-slide-menu__header">
      <button
        type="button"
        appButton
    variant="ghost"
    iconOnly
    motion="back"
    class="mobile-slide-menu__back"
        (click)="close()"
        [attr.aria-label]="'header.closeSecondaryMenu' | translate"
        >
        <fa-icon [icon]="faArrowLeft"></fa-icon>
      </button>
      <h2 class="mobile-slide-menu__title">{{ "header.secondaryMenu" | translate }}</h2>
    </header>

    <nav class="mobile-slide-menu__nav" [attr.aria-label]="'header.secondaryMenu' | translate">
      @for (item of menuItems(); track item.route) {
        <a
          class="mobile-slide-menu__item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="item.linkActiveOptions ?? exactLinkActiveOptions"
          (click)="close()"
          >
          @if (item.navIcon; as navIconId) {
            <svg
              class="mobile-slide-menu__icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              [innerHTML]="customNavIcons[navIconId] | sanitizeHtml"
            ></svg>
          } @else {
            <fa-icon class="mobile-slide-menu__icon" [icon]="item.icon!" />
          }
          <span>{{ item.labelKey | translate }}</span>
          <fa-icon class="mobile-slide-menu__chevron" [icon]="faChevronRight"></fa-icon>
        </a>
      }
    </nav>

    @if (pwaInstall.canOffer()) {
      <footer class="mobile-slide-menu__footer">
        <app-install-app-button fullWidth />
      </footer>
    }
  </aside>
</div>
